module.exports = "/_next/static/images/Reviews-3701c894f3f1d65b9effcaea4f9f1eae.png";